// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';

import DigestMenuTemplate from 'analyses/DigestMenuTemplate';
import DigestTabState from 'analyses/DigestTabState';
import DigestTabTemplate from 'analyses/DigestTabTemplate';
import FragmentRowTemplate, {FragmentRowProps} from 'analyses/FragmentRowTemplate';
import * as analytics from 'analytics/Analytics';
import {Sequence as BioJSSequence} from 'biojs/Sequence';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {Sequence as ComponentSequence} from 'components/Sequence';
import EnzymeActivityTable from 'molbio/enzymes/EnzymeActivityTable';
import {Provider} from 'molbio/enzymes/EnzymeConstants';
import EnzymeProviderSelector from 'molbio/enzymes/EnzymeProviderSelector';
import * as EnzymeUtil from 'molbio/enzymes/EnzymeUtil';
import * as sequtil from 'molbio/SeqUtil';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import getTestProps from 'test/lib/cypress/getTestProps';

interface FragmentRowViewOptions extends Backbone.ViewOptions<BioJSSequence> {
  sequence: ComponentSequence;
}

class OptionsView extends Backbone.View<DigestTabState> {
  sequence!: ComponentSequence;
  name!: JQuery;
  template!: () => string;

  static initClass(): void {
    this.prototype.tagName = 'div';
    this.prototype.className = 'navbar';
    this.prototype.template = DigestMenuTemplate;

    this.prototype.events = {
      // @ts-expect-error Backbone vendored types model events as a function, not a hash
      'click .save': 'save',
      'keypress .tab-name': 'checkEnter',
      'keyup .tab-name': 'setFromText',
    };
  }

  override initialize(): void {
    this.updateProvider = this.updateProvider.bind(this);
    this.sequence = this.model.get('sequence');
    // eslint-disable-next-line @typescript-eslint/unbound-method -- bound via bind() above for onChange
    this.listenTo(this.model.get('analysis'), 'change:provider', this.renderProviderSelector);
  }

  setFromText(): void {
    this.model.set('title', this.name.val().trim());
  }

  checkEnter(e: JQueryEventObject): void {
    if (e.which === 13) {
      this.save();
    }
  }

  save(): void {
    if (!this.model.get('sequence').allowFeatureEdits()) {
      return;
    }
    this.$('.save').button('loading');

    const analysis = this.model.get('analysis');
    analysis.set('name', this.name.val().trim());
    const saveWord = analysis.isNew() ? 'saved' : 'updated';
    const savePromise = this.sequence
      .get('analyses')
      .betterCreate(analysis) as unknown as JQueryPromise<Backbone.Model>; // legacy code chains even when validation returns false
    savePromise
      .always(() => this.$('.save').button('reset'))
      .done(() => {
        notifications.success(
          <>
            Digest <strong>{this.name.val()}</strong> successfully {saveWord}.
          </>
        );
        analytics.track('digest', 'saved_digest', {name: analysis.get('name')});
      })
      .fail(notifications.notifyError);
  }

  updateProvider(provider: Provider): void {
    this.model.get('analysis').set({provider: provider.name});
  }

  renderProviderSelector(): void {
    const analysis = this.model.get('analysis');
    const allowFeatureEdits = this.sequence.allowFeatureEdits();

    const providers = EnzymeUtil.getProvidersForEnzymes(analysis.get('enzymes') ?? []);
    const selectedProvider = analysis.provider();

    renderToDOM(
      <EnzymeProviderSelector
        inline={true}
        providers={providers}
        value={selectedProvider}
        // eslint-disable-next-line @typescript-eslint/unbound-method -- bound in initialize()
        onChange={allowFeatureEdits ? this.updateProvider : undefined}
      />,
      this.$el.find('.enzymes-providers-mount')[0]
    );
  }

  override render(): this {
    this.$el.html(this.template());
    this.renderProviderSelector();
    this.name = this.$el.find('.tab-name');
    if (!this.sequence.allowFeatureEdits()) {
      this.name.prop('readonly', true);
      this.$('.save').addClass('disabled').text('Save (disabled in read-only mode)');
    }

    this.$('.save').attr({type: 'button', 'data-loading-text': 'Saving...'});

    this.name.val(this.model.get('analysis').get('name') ?? '');
    return this;
  }
}
// eslint-disable-next-line new-cap -- decaffeinate initClass pattern
OptionsView.initClass();

class FragmentRowView extends Backbone.View<BioJSSequence> {
  sequence!: ComponentSequence;
  template!: (props: FragmentRowProps) => string;

  static initClass(): void {
    this.prototype.tagName = 'tr';
    this.prototype.template = FragmentRowTemplate;

    this.prototype.events = {
      // @ts-expect-error Backbone vendored types model events as a function, not a hash
      mousedown: 'selectFragment',
      contextmenu: 'contextMenu',
    };

    this.prototype.attributes = {
      ...this.prototype.attributes,
      ...getTestProps({component: 'FragmentRow', element: 'row'}),
    };
  }

  override initialize(options: FragmentRowViewOptions): void {
    this.sequence = options.sequence;
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone passes model as first arg
    this.listenTo(this.model, 'change:selected', this.handleSelectedChange);
  }

  contextMenu(e: JQueryEventObject): void {
    selectioncontextmenu.open(e, this.sequence, selectioncontextmenu.COPY_MENU);
  }

  selectFragment(): void {
    this.sequence.selectFragment(this.model);
  }

  handleSelectedChange(model: BioJSSequence, selected: boolean): void {
    this.$el.toggleClass('active', selected);
  }

  override render(): this {
    const leftCutterOverhang = this.model.leftOverhang();
    let leftCutterName = this.model.get('_cutter5')?.name;
    leftCutterName = leftCutterName != null ? leftCutterName : 'None';
    const rightCutterOverhang = this.model.rightOverhang();
    let rightCutterName = this.model.get('_cutter3')?.name;
    rightCutterName = rightCutterName != null ? rightCutterName : 'None';
    const [start, end] = sequtil.modelRangeToDisplay(
      this.model.get('start')!,
      this.model.get('end')!,
      this.sequence.length(),
      this.sequence.startIndex()
    );
    this.$el.html(
      this.template({
        start,
        end,
        length: this.model.get('length'),
        leftCutterName,
        leftCutterOverhang,
        rightCutterName,
        rightCutterOverhang,
      })
    );
    if (this.model.get('selected')) {
      this.$el.addClass('active');
    }
    return this;
  }
}
// eslint-disable-next-line new-cap -- decaffeinate initClass pattern
FragmentRowView.initClass();

class TabView extends Backbone.View<DigestTabState> {
  sequence!: ComponentSequence;
  _sequence!: BioJSSequence;
  rows!: Array<FragmentRowView>;
  template!: () => string;

  static initClass(): void {
    this.prototype.template = DigestTabTemplate;
    this.prototype.className = 'buffer-tab';
    this.prototype.events = {
      // @ts-expect-error Backbone vendored types model events as a function, not a hash
      'click tr': 'selectFragment',
    };
  }

  override initialize(): void {
    this.sequence = this.model.get('sequence');
    this._sequence = this.sequence.get('_sequence');
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone binds this on invoke
    this.listenTo(this._sequence, 'change:circular change:bases change:startIndex', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone binds this on invoke
    this.listenTo(this.model, 'change:fragments', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method -- Backbone binds this on invoke
    this.listenTo(this.model.get('analysis'), 'change:provider', this.renderEnzymes);
    this.rows = [];
  }

  renderEnzymes(): void {
    const provider = this.model.get('analysis').provider();
    const enzymeIds = this.model.get('analysis').get('enzymes') ?? [];
    const enzymes = this.sequence.get('enzymes').getEnzymesJSON(enzymeIds);
    renderToDOM(<EnzymeActivityTable provider={provider} enzymes={enzymes} />, this.$el.find('.enzymes')[0]);
  }

  override render(): this {
    const enzymeIds = this.model.get('analysis').get('enzymes') ?? [];
    const enzymes = this.sequence.get('enzymes').getEnzymesJSON(enzymeIds);

    this.$el.html(this.template());
    this.renderEnzymes();

    if (enzymes.length !== 0) {
      const fragments = this.model.get('analysis').get('fragments')!;
      for (const fragment of Array.from(fragments.models)) {
        const row = new FragmentRowView({
          model: fragment,
          sequence: this.sequence,
        } as FragmentRowViewOptions);
        this.rows.push(row);
        this.$el.find('.fragments-table tbody').append(row.render().el);
      }
    }
    return this;
  }

  override remove(): Backbone.View<DigestTabState> {
    for (const row of Array.from(this.rows)) {
      row.stopListening();
    }
    return super.remove();
  }
}
// eslint-disable-next-line new-cap -- decaffeinate initClass pattern
TabView.initClass();

export {OptionsView, TabView};
